// Swarm registry for Projects — investor-redacted display names (must match
// the sidebar labels). `key` values align with backend VALID_SWARMS.
export const PROJECT_SWARMS = [
  { key: "haven", label: "HAVEN" },
  { key: "retail", label: "Retail" },
  { key: "pharmaceutical", label: "Pharmaceutical" },
  { key: "contentry", label: "Brand Management" },
  { key: "rightsline", label: "Licensing" },
  { key: "csh", label: "Grants" },
  { key: "pe_fund_1", label: "Private Equity I" },
  { key: "pe_fund_2", label: "Private Equity II" },
];

export const SWARM_LABEL = PROJECT_SWARMS.reduce((m, s) => { m[s.key] = s.label; return m; }, {});
